const waitForElement = setInterval(() => {
  const target = document.querySelector(".monster_upsell_rtl");
  if (target) {
    clearInterval(waitForElement);

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (
          mutation.type === "attributes" &&
          mutation.attributeName === "class"
        ) {
          if (target.classList.contains("mu_openned")) {
            handlePrice();
            handle();
          }
        }
      });
    });

    observer.observe(target, {
      attributes: true,
      attributeFilter: ["class"]
    });
  }
}, 200);

function handlePrice(){const lineItem = document.querySelectorAll(".mu-cart-item");
lineItem.forEach(item => {
    const title = item.querySelector(".mu-item-title").innerText;
    const variant = item.querySelector(".mu-item-variants").innerText;
    let cartKey = '';
    BSS_B2B.shopData.cart.items.forEach(i => {
        if(title === i.product_title) {
            cartKey = i.key;
        }
    })
    console.log({title, cartKey})
    const price = item.querySelector(".mu-item-price");
    price.setAttribute("bss-b2b-cart-item-key", cartKey);
    price.setAttribute("bss-b2b-final-line-price", "true");
})
  document.querySelector(".mu-subtotal .money").setAttribute("bss-b2b-cart-total-price", "true")
  BSS_B2B.observer.cartSubject.notifyObserver('CartUpdate', 'CartMutate');
}

function handle(){
  const target = document.querySelector('#mu-checkout-button');
  if (target) {
    const prev = target.previousElementSibling;
  
    const isAlreadyInserted = prev &&
      prev.tagName.toLowerCase() === 'button' &&
      prev.classList.contains('bss-custom') &&
      prev.textContent.trim() === 'Fortsätt till kassan';
  
    if (!isAlreadyInserted) {
   target.insertAdjacentHTML('beforebegin', `
        <button class="bss-custom mu-custom-btn mu-w-full mu-py-3 mu-mb-2 mu-checkout-btn mu-flex mu-items-center mu-justify-center mu-rounded" style="
          background-color: rgb(42, 71, 60);
          border: inherit;
          text-decoration: none;
          font-family: inherit;
          font-size: 1.3em;
          color: rgb(255, 255, 255);
          --hover-background: rgba(215, 222, 255, 1);
        ">
          Fortsätt till kassan
        </button>
      `);
      target.style.display = 'none';
    }
    BSS_B2B.observer.cartSubject.listenCartCheckout()
  }
}